import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function VacationAdmin() {
  const { fetchAllVacations, approveVacation, rejectVacation, suggestVacation } = useAuth();
  const [vacations, setVacations] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const v = await fetchAllVacations();
    setVacations(v);
  };

  useEffect(() => { load(); }, []);

  const handleApprove = async (id) => {
    await approveVacation(id);
    load();
  };

  const handleReject = async (id) => {
    await rejectVacation(id);
    load();
  };

  const handleSuggest = async () => {
    await suggestVacation(editing.id, {
      suggestedStart: editing.suggestedStart,
      suggestedEnd: editing.suggestedEnd,
      adminComment: editing.adminComment
    });
    setEditing(null);
    load();
  };

  return (
    <div className="container mt-5">
      <h3 className="mb-4">Admin – Hantera semesterförfrågningar</h3>

      {vacations.map(v => (
        <div key={v._id} className="card mb-2">
          <div className="card-body">
            <strong>{v.userId?.firstName} {v.userId?.lastName}</strong>  
            <div>Ansökt: {new Date(v.startDate).toLocaleDateString("sv-SE")} – {new Date(v.endDate).toLocaleDateString("sv-SE")}</div>
            <div>Status: <span className="badge bg-secondary">{v.status}</span></div>
            {v.comment && <div>Kommentar: {v.comment}</div>}
            {v.status === "Förfrågan" && (
              <div className="mt-2">
                <button className="btn btn-success btn-sm me-2" onClick={() => handleApprove(v._id)}>Bevilja</button>
                <button className="btn btn-warning btn-sm me-2" onClick={() => setEditing({
                  id: v._id,
                  suggestedStart: v.startDate.slice(0,10),
                  suggestedEnd: v.endDate.slice(0,10),
                  adminComment: ""
                })}>Föreslå ändring</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleReject(v._id)}>Avslå</button>
              </div>
            )}
          </div>
        </div>
      ))}

      {editing && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Föreslå ändring</h5>
                <button className="btn-close" onClick={() => setEditing(null)}></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Start</label>
                <input type="date" className="form-control mb-2"
                  value={editing.suggestedStart}
                  onChange={e => setEditing({ ...editing, suggestedStart: e.target.value })} />
                <label className="form-label">Slut</label>
                <input type="date" className="form-control mb-2"
                  value={editing.suggestedEnd}
                  onChange={e => setEditing({ ...editing, suggestedEnd: e.target.value })} />
                <label className="form-label">Kommentar</label>
                <textarea className="form-control"
                  value={editing.adminComment}
                  onChange={e => setEditing({ ...editing, adminComment: e.target.value })} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditing(null)}>Avbryt</button>
                <button className="btn btn-primary" onClick={handleSuggest}>Spara</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
